import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmRejectReasonType } from '../interfaces/IKnmRejectReasonType';

export async function fetchKnmRejectReasonTypes(knmTypeId: number): Promise<IKnmRejectReasonType[]> {
  return apiGet<IKnmRejectReasonType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-reject-reason-types/${knmTypeId}`,
  );
}

export async function fetchErknmKnmRejectReasonTypes(isPlaned: boolean): Promise<IKnmRejectReasonType[]> {
  const queryParams = new URLSearchParams();

  queryParams.append('isPlaned', isPlaned.toString());

  return apiGet<IKnmRejectReasonType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/erknm/knm-reject-reason-types?${queryParams}`,
  );
}
